import { LiveIcon as StyledLiveIcon, LiveIconWrapper } from "./styled";

export const LiveIcon = ({ size = 13 }) => {
  return (
    <LiveIconWrapper size={size}>
      <StyledLiveIcon size={size} />
    </LiveIconWrapper>
  );
};
